var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrocery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "droplets-03"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M8.37333 4.05268C8.83184 3.3201 9.15687 2.51204 9.33333 1.66602C9.66667 3.33268 10.6667 4.93268 12 5.99935C13.3333 7.06602 14 8.33268 14 9.66602C14.0038 10.5875 13.7339 11.4895 13.2245 12.2574C12.7151 13.0254 11.9892 13.6248 11.1388 13.9797C10.2883 14.3346 9.35161 14.429 8.44745 14.2509C7.54328 14.0728 6.71236 13.6302 6.06 12.9793M4.66667 10.5193C6.13333 10.5193 7.33333 9.29935 7.33333 7.81935C7.33333 7.04602 6.95333 6.31268 6.19333 5.69268C5.43333 5.07268 4.86 4.15268 4.66667 3.18602C4.47333 4.15268 3.90667 5.07935 3.14 5.69268C2.37333 6.30602 2 7.05268 2 7.81935C2 9.29935 3.2 10.5193 4.66667 10.5193Z",
    stroke: "#01588C",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrocery);
export default __webpack_public_path__ + "static/media/grocery.23ca137b06dff6d8308787f3101a4941.svg";
export { ForwardRef as ReactComponent };